/**
 * @flow
 */

import { useMemo, useEffect } from "react";
import throttle from "lodash/throttle";

/**
 * https://github.com/streamich/react-use/issues/372#issuecomment-500235222
 */
export const useThrottleFn = (
  // Generic callback whose args are contravariant; unknown would reject real callers.
  // $FlowFixMe[unclear-type]
  fn: (...args: Array<any>) => any,
  ms: number = 1000
  // lodash throttle returns fn intersected with Cancelable, which our libdefs do not model.
  // $FlowFixMe[unclear-type]
): ((...args: Array<any>) => any) & any => {
  // Should "Cancelable" instead of & any, but our types don't cover this.
  const throttledFn = useMemo(() => {
    return throttle(fn, ms);
  }, [fn, ms]);
  // This is a must because fn can call setState.
  useEffect(() => {
    return () => {
      throttledFn.cancel();
    };
  }, [throttledFn]);
  return throttledFn;
};
